import * as CONST from '../const';
class UIWrapper {
    owner;
    constructor(owner) {
        this.owner = owner;
    }
    getContainerClass(type = 'main') {
        return `calculator-container-${type}`;
    }
    renderInContainer(cont) {
        cont.dataset.calculatorId = this.owner.getUniqueId();
        cont.classList.add(this.getContainerClass());
        cont.innerHTML =
            `<div><div class="calc-preview calc-preview-wrapper text-center">
          <div class="calc-preview-img_wrapper">
            <div class="calc-preview-img ">
              <div class="calc_preview_in_room calc_preview_frame">
                <div class="calc_preview_topRow">
                  <div class="bagetCorner calc_preview_topLeft">&nbsp;</div>
                  <div class="bagetHorizontal calc_preview_top">&nbsp;</div>
                  <div class="bagetCorner baget-corner-top-right calc_preview_topRight">&nbsp;</div>
                </div>
                <div class="calc_preview_middleRow">
                  <div class="bagetVertical baget-side-left calc_preview_left">&nbsp;</div>
                  <div class="bagetVertical calc_preview_center">&nbsp;
                    <div class="calc_preview_center_image">&nbsp;</div>
                  </div>
                  <div class="bagetVertical baget-side-right calc_preview_right" >&nbsp;</div>
                </div>
                <div class="calc_preview_bottomRow">
                  <div class="bagetCorner baget-corner-bottom-left calc_preview_bottomLeft" >&nbsp;</div>
                  <div class="bagetHorizontal calc_preview_bottom" >&nbsp;</div>
                  <div class="bagetCorner baget-corner-bottom-right calc_preview_bottomRight" >&nbsp;</div>
                </div>
              </div>
              <img width="628" height="397" decoding="async" loading="lazy" alt="Поле для выбора размера холста" class="back" src="${CONST.DEFAULT_IMAGE}" />
              <div class="calc-preview-overlay show_closeup">
                <div>Увеличить</div>
              </div>
            </div>
          </div>
          <div class="prices-row-bottom">
            <span class="${CONST.CLASS_PREFIX}price_original inline_total_price_original">10000</span>
            <span class="${CONST.CLASS_PREFIX}price inline_total_price">10000</span>
          </div>
        </div>
        <div class=" ${CONST.CLASS_PREFIX}steps scrollBlock"></div></div>` +
                (this.getFormHTML());
        const showTrigger = cont.querySelector('.show_closeup');
        showTrigger && showTrigger.addEventListener('click', (e) => this.owner.showCloseup(e));
    }
    getFormHTML() {
        if (this.owner.getOptions().renderForm) {
            let result = '';
            result += (`
      <div id="files_drop">
      <input type="file" name="files" class="${CONST.FILE_UPLOADER_INPUT_CLASS}" multiple="multiple">
      </div>`);
            result += (`<div class="text-center ${CONST.CLASS_PREFIX}form"></div>`);
            return result;
        }
        else {
            return '';
        }
    }
    render() {
        if (this.owner) {
            const cont = this.owner.getContainerElement();
            if (cont) {
                this.renderInContainer(cont);
            }
        }
    }
}
export default UIWrapper;
